import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTelegramModal } from '../context/TelegramModalContext';
import logoImage from '../assets/logo_site.png?inline';
import { PlaneIcon, PlugIcon } from './Icons';
import { openTelegramAppLink } from '../utils/telegramLinks';

function TelegramModal() {
    const { isOpen, botLink, actionLabel, closeTelegramModal } = useTelegramModal();
    const [copied, setCopied] = useState(false);
    const navigate = useNavigate();

    // Extract bot username from link
    const botUsername = botLink ? botLink.split('/').pop().split('?')[0] : 'bot';
    const displayUsername = botUsername.startsWith('@') ? botUsername : `@${botUsername}`;

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('tg-modal-open');
            document.documentElement.classList.add('tg-modal-open');
        } else {
            document.body.classList.remove('tg-modal-open');
            document.documentElement.classList.remove('tg-modal-open');
        }

        return () => {
            document.body.classList.remove('tg-modal-open');
            document.documentElement.classList.remove('tg-modal-open');
        };
    }, [isOpen]);

    const handleCopy = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(displayUsername);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    }, [displayUsername]);

    const handleConnectProxy = () => {
        closeTelegramModal();
        navigate('/proxy');
    };

    const handleContinueToBot = () => {
        openTelegramAppLink(botLink, { webFallback: false });
        closeTelegramModal();
    };

    return (
        <div
            className={`tg-modal-overlay ${isOpen ? 'tg-modal-overlay--visible' : ''}`}
            onClick={closeTelegramModal}
            aria-hidden={!isOpen}
            inert={!isOpen ? true : undefined}
        >
            <div className={`tg-modal-card ${isOpen ? 'tg-modal-card--visible' : ''}`} onClick={(e) => e.stopPropagation()}>
                {/* Close Button */}
                <button className="tg-modal-close" onClick={closeTelegramModal} aria-label="Закрыть">
                    <span className="tg-modal-close__line" aria-hidden="true"></span>
                    <span className="tg-modal-close__line" aria-hidden="true"></span>
                    <span className="tg-modal-close__line tg-modal-close__line--hidden" aria-hidden="true"></span>
                </button>

                <div className="tg-modal-content">
                    <div className="tg-modal-header">
                        <div className="tg-modal-icon">
                            <span className="tg-modal-icon__frame">
                                <img src={logoImage} alt="" width="32" height="32" loading="eager" decoding="async" />
                            </span>
                        </div>
                        <h2 className="tg-modal-title">Открытие Telegram</h2>
                        <div className="tg-modal-username-row" onClick={handleCopy}>
                            <span className="tg-modal-username">{displayUsername}</span>
                            <button className={`tg-modal-copy-btn ${copied ? 'tg-modal-copy-btn--copied' : ''}`}>
                                {copied ? (
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                ) : (
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" /><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="tg-modal-body">
                        <p className="tg-modal-text">
                            Если Telegram не открывается автоматически — возможно, прямые ссылки заблокированы в вашем регионе.
                        </p>
                        
                        <div className="tg-modal-steps">
                            <div className="tg-modal-step">
                                <div className="tg-modal-step-number">1</div>
                                <div className="tg-modal-step-text">
                                    Убедитесь, что приложение <strong>Telegram обновлено до последней версии</strong>
                                </div>
                            </div>
                            <div className="tg-modal-step">
                                <div className="tg-modal-step-number">2</div>
                                <div className="tg-modal-step-text">
                                    <strong>Подключите прокси</strong> для обхода блокировок Telegram
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="tg-modal-actions">
                        <button className="tg-modal-btn tg-modal-btn--proxy" onClick={handleConnectProxy}>
                            <span className="tg-modal-btn__icon" aria-hidden="true">
                                <PlugIcon className="tg-modal-btn__plug-svg" />
                            </span>
                            Подключить прокси
                        </button>
                        <button className="tg-modal-btn tg-modal-btn--bot" onClick={handleContinueToBot}>
                            <PlaneIcon className="tg-modal-btn__plane-icon" size={18} />
                            {actionLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TelegramModal;
